/* globals jQuery */
const $ = jQuery;

function calculatePositions( current, total ) {
	let next = current + 1;
	let prev = current - 1;

	if ( next >= total ) {
		next = 0;
	}

	if ( prev < 0 ) {
		prev = total - 1;
	}

	return [ next, prev ];
}

export default function() {
	const $carousel = $( this );
	const $slides = $carousel.find( '.js-slide' );
	const $indicatorCurrent = $carousel.find( '.js-current' );
	const $indicatorTotal = $carousel.find( '.js-total' );
	const $buttons = $carousel.find( '.js-prev, .js-next' );

	const vertical = $( this ).hasClass( 'vertical-carousel' );

	const total = $slides.length;
	let current = 0;
	let prev = total - 1;
	let next = 1;

	let minHeight = 0;
	$slides.each( function() {
		minHeight = Math.max( minHeight, $( this ).height() );
	} );

	$carousel.find( '.js-slides-wrap' ).css( 'min-height', minHeight + 'px' );

	$indicatorTotal.text( total );
	$carousel.on( 'carousel:update', function() {
		$indicatorCurrent.text( current + 1 );
	} );

	$slides.first().addClass( 'is-current' );

	if ( $carousel.hasClass( 'with-previews' ) ) {
		const $buttonPrev = $carousel.find( '.js-prev' );
		const $buttonNext = $carousel.find( '.js-next' );

		$carousel.on( 'carousel:update', function() {
			$buttonPrev.css( 'background-image', `url(${ $slides.eq( prev ).data( 'thumb' ) })` );
			$buttonNext.css( 'background-image', `url(${ $slides.eq( next ).data( 'thumb' ) })` );
		} );
	}

	function changeSlide( index, isPrev ) {
		if ( index === null ) {
			[ index ] = calculatePositions( current, total, isPrev );
		}

		const outClass = `animating-out animating-out--${ isPrev ? 'prev' : 'next' }`;
		const inClass = `animating-in animating-in--${ isPrev ? 'prev' : 'next' }`;

		$slides.eq( current ).cssAnimate( outClass, function() {
			$( this ).removeClass( 'is-current' ).removeClass( outClass );
		} );

		$slides.eq( index ).cssAnimate( inClass, function() {
			$( this ).addClass( 'is-current' ).removeClass( inClass );
		} );

		current = index;
		[ next, prev ] = calculatePositions( current, total );

		$carousel.trigger( 'carousel:update' );
	}

	$buttons.click( function() {
		changeSlide( null, $( this ).hasClass( 'js-prev' ) );
	} );

	let useNavButtons = false;
	$( this ).on( 'mouseenter mouseleave', function( e ) {
		useNavButtons = e.type === 'mouseenter';
	} );

	const nextKey = vertical ? 40 : 39;
	const prevKey = vertical ? 38 : 37;

	$( document ).on( 'keydown', function( e ) {
		if ( ! useNavButtons ) {
			return;
		}

		if ( e.which === nextKey || e.which === prevKey ) {
			e.preventDefault();
			changeSlide( null, e.which === prevKey );
		}
	} );

	$carousel.trigger( 'carousel:update' );
}
